import PaymentMethod from '@/orm/models/Account/PaymentMethod';
import { computed } from '@vue/composition-api';

export default function usePaymentMethods() {
  const paymentMethods = computed(() => PaymentMethod.query().all());

  async function fetchAll(once) {
    if (once && paymentMethods.value.length) {
      return;
    }
    await PaymentMethod.api().fetch();
  }
  async function deleteMethod(id) {
    await PaymentMethod.api().destroy(id);
    await PaymentMethod.delete(id);
  }

  async function setActive(id) {
    await PaymentMethod.api().active(id);
    await fetchAll();
  }

  async function updateData(id, data) {
    await PaymentMethod.api().updateData({ id, data });
  }

  const activePaymentMethod = computed(() => {
    return PaymentMethod.query()
      .where('active', true)
      .first();
  });

  return {
    fetchAll,
    activePaymentMethod,
    paymentMethods,
    deleteMethod,
    setActive,
    updateData,
  };
}
